/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Questionnaire } from 'components/questionnaire'
import { Quote } from 'components/quote'
import { withRail } from 'components/rail'
import { Waypoint } from 'react-waypoint'
import Scrollchor from 'react-scrollchor'

// TODO Set the correct article ID here
const ARTICLE_ID = '31559757'

// track downClicks
const trackDownClicks = target => {
  const clickedText = target
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'Interactions',
    // eslint-disable-next-line
    event_action: 'click',
    // eslint-disable-next-line
    event_label: 'DownClickTo: ' + clickedText
  })
}

/**
 * Show a block for jumping directly to the Zurich part
 */
const jumpMessage = () => (
  <div className='jump-message'>
    <div className='ui info top attached message'>
      <i className='icon user md big' />
      <div>Sie interessieren sich für den Testosteroncheck?</div>
    </div>
    <Scrollchor
      to='testosteroncheck'
      className='ui primary fluid bottom attached button'
    >
      <div onClick={() => trackDownClicks('testosteroncheck')}>
        <i className='down arrow icon' />
        Direkt zum Fragebogen
      </div>
    </Scrollchor>
  </div>
)

const RailedJumpMessage = withRail(jumpMessage)
// eslint-disable-next-line no-unused-vars

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} inverted />
      <ThemeSwitch />

      <header className='ui titleImage'>
        <div className='headline'>
          <h1>«Jeder Vierte im Alter von 45 hat Erektions&shy;probleme»</h1>
        </div>
      </header>
      <div className='ui container'>
        <div className='ta secondary caption'>
          3D-Illustration von Spermien. Foto: Christoph Burgstedt/Getty Images
        </div>
      </div>

      <div className='ui vertical segment' style={{ paddingBottom: '0' }}>
        <div className='ui text container'>
          <div className='ta lead'>
            «Mann 2020» heisst das Buch von Urologe Markus Margreiter. Im
            Gespräch erklärt der Mediziner, wieso Männer heute weniger
            Testosteron haben und was Tinder mit dem besten Stück anstellt.
          </div>
          <div className='ta author'>Philippe Zweifel und Interaktiv-Team</div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <RailedJumpMessage side='right' />
          <p>
            Ist die Männlichkeit in der Krise? Von weinerlichen
            «Schmerzensmännern» liest man genauso wie von «toxischen Männern»,
            die dominant auftreten und unfähig sind, über ihre Gefühle zu reden.
            Das Mannsein, so scheint es, ist fast schon eine Krankheit. Höchste
            Zeit also, mit einem vom Fach darüber zu reden. Urologe Markus
            Margreiter hat nach eigenen Angaben jeden Tag einen Penis in der
            Hand - und weiss auch sonst genau Bescheid, wie es um seine
            Geschlechtsgenossen bestellt ist.
          </p>
          <p className='question'>
            Herr Margreiter, wie geht es den Männern aus urologischer Sicht?
          </p>
          <p>
            In der Männergesundheit hat sich in den letzten 20 Jahren sehr viel
            getan. Es zeichnet sich insbesondere ab, dass jüngere Männer weniger
            Mühe haben, über Gesundheitsthemen und sexuelle Probleme zu
            sprechen. Was weniger erfreulich ist: Eine US-Studie hat gezeigt,
            dass seit dem Aufstieg der Dating-Apps die Raten von sexuell
            übertragbaren Krankheiten wie Syphilis oder Tripper drastisch
            angestiegen sind. Auch ist ein deutlicher Anstieg von
            Erektionsproblemen in den letzten 20 bis 30 Jahren zu verzeichnen.
            Jeder vierte Mann im Alter von 45 hat in dieser Hinsicht bereits
            Probleme. Die Hälfte davon schwere bis mittelschwere.
          </p>

          <p className='question'>Was heisst das konkret?</p>
          <p>
            Als Erektionsstörung bezeichnet man die anhaltende Unfähigkeit, eine
            Erektion zu erreichen oder während des Geschlechtsverkehrs
            aufrechtzuerhalten. Für den Arzt ist das von aussen nicht zu sehen,
            er kann nur danach fragen und ist auf die Beschreibung des Patienten
            angewiesen. Doch dieser ist oftmals so geniert, dass er die Sache
            herunterspielt oder so entsetzt ist, dass er überzeichnet.
          </p>

          <div className='boxWrapper'>
            <div className='imgContainer' />
            <div className='textContainer'>
              <b>Dr. Markus Margreiter</b> ist Facharzt für Urologie und führt
              ein privates Männergesundheitszentrum in Wien. Zuvor leitete er
              dort an der Uniklinik die Ambulanz für Andrologie und Erek­tile
              Dysfunktion. Mit «Mann 2020» bietet er einen spannenden Einblick
              in den aktuellen Stand der Männermedizin. <br />
              Buch: «Mann 2020», 272 S., ca. 22 Fr.
            </div>
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  // eslint-disable-next-line
                  event_action: 'vertical-scroll',
                  // eslint-disable-next-line
                  event_label: '20ContentRead'
                })
              }
            }}
          />

          <p className='question'>
            Was sind die Ursachen für die erschlaffenden Männer?
          </p>
          <p>
            Es kann an der Durchblutung, den Nerven, den Hormonen oder dem Kopf
            liegen. Natürlich gibt es auch jegliche Kombinationen daraus. Gerade
            krankheitsfördernde Lebensumstände wie Überernährung,
            Bewegungsmangel, Stress, Rauchen oder einige Medikamente wirken sich
            negativ auf die männlichen Sexualfunktionen aus. Psychologische
            Faktoren spielen insbesondere bei jüngeren Männern eine grosse
            Rolle. Die Änderung des männlichen Rollenbildes und die
            Digitalisierung der Sexualität könnten hier einen Einfluss haben.
          </p>
          <p className='question'>Was tun bei einer erektilen Dysfunktion?</p>
          <p>
            In den letzten Jahren wurden verschiedene neue Möglichkeiten
            entwickelt, um dem Mann mit Potenzproblemen zu helfen. Da war
            einerseits der Siegeszug des Medikaments Viagra, das die Behandlung
            revolutioniert hat. Jedoch sprechen 30 bis 35 Prozent der Patienten
            nicht oder nicht ausreichend auf diese Behandlungsform an. Für diese
            gibt es aber eine Vielzahl an alternativen Möglichkeiten, zum
            Beispiel Stent-Behandlungen, Schwellkörperimplantate oder
            Stosswellentherapie.
          </p>

          <p className='question'>
            Stosswellentherapie klingt unheimlich. Wie funktioniert die?
          </p>
          <p>
            Die Technik kommt ursprünglich aus der Luftfahrt. An
            Überschallflugzeugen stellte man fest, dass Stosswellen Material
            zerstören können. In der Medizin nutzte man dies zuerst, um
            Nierensteine zu zertrümmern. Später wurden sie auch in der
            Wundheilung eingesetzt. 2010 kam die erste Studie heraus, mit der
            nachgewiesen wurde, dass niedrig dosierte Stosswellen das
            Schwellkörpergewebe im Penis regenerieren können.
          </p>

          <p className='question'>
            Sollte man sich nicht zuerst beim Sextherapeuten Hilfe holen?
          </p>
          <p>
            Eine ganzheitliche Abklärung inklusive sexualtherapeutischer
            Evaluierung ist natürlich ideal. Sexuelle Störungen können unter
            anderem Indikatoren für psychische Probleme sein. Es gibt die schöne
            Metapher des Penis als «Antenne des Herzens», das stimmt im
            übertragenen Sinn ebenso wie buchstäblich – Erektionsstörungen sind
            oftmals das erste Anzeichen von Herz-Kreislauf-Erkrankungen. Das
            Problem ist, dass viele Männer darüber nicht einmal gegenüber ihrem
            Hausarzt bereitwillig Auskunft geben und erst recht nicht gern zum
            Urologen gehen.
          </p>

          <p className='question'>Wieso?</p>
          <p>
            Der Urologe gilt bei vielen Männern als Schreckgespenst: weil er mit
            Prostatakrebs assoziiert wird und wegen der vermeintlich
            unangenehmen Tastuntersuchung der Prostata. Ich merke das schon,
            wenn ich mich in einer privaten Runde vorstelle: Sage ich, ich sei
            Urologe, gucken die Männer verschämt drein. Stelle ich mich als
            Leiter eines Zentrums für Männergesundheit vor, zeigen sie sich
            interessiert.
          </p>

          <p className='question'>
            Haben Sie eigentlich jeden Tag einen Penis in der Hand?
          </p>
          <p>
            Interessante Frage. Ja, das ist Teil meiner urologischen Tätigkeit
            im OP oder bei Untersuchungen. Obwohl ich das völlig neutral sehe,
            ist mir bewusst, dass es für viele Männer schambehaftet ist. Umso
            wichtiger ist ein empathischer Zugang.
          </p>
          <Quote side='left'>
            <div className='ui small header turquoise'>
              «Die Nasen-Penis-Korrelation gibt es nicht»
            </div>
          </Quote>
          <p className='question'>
            Welche Penis-Mythen können Sie bestätigen – und welche widerlegen?
          </p>
          <p>
            Sie meinen die Nasen-Penis-Korrelation? Da gibt es nur wenige, die
            wirklich halten. So ist auch die Menge des Ejakulats keine Messlatte
            für die Potenz, sie hängt von Alter, Prostata und den Samenblasen
            ab, in denen der Grossteil der Flüssigkeit produziert wird. Was
            stimmt: je sportlicher einer ist, desto bessere gesundheitliche und
            urologische Werte hat er. Und auch sexuelle Aktivität wirkt sich
            positiv auf die Einsatzfähigkeit des besten Stücks aus – «use it or
            lose it».
          </p>

          <p className='question'>
            Sie schreiben in Ihrem Buch, dass viele Männer gern einen grösseren
            Penis hätten.
          </p>
          <p>
            Das scheint tatsächlich so. Leider werden die Männer oft von
            falschen Vorstellungen geleitet. Im Gegensatz zur Brustvergrösserung
            bei der Frau ist beim Mann aus medizinischer Sicht aktuell nicht
            viel möglich.
          </p>

          <p className='question'>Implantate bringen nichts?</p>
          <p>
            Schwellkörperimplantate haben einen wichtigen funktionellen Nutzen
            bei Männern mit schwersten Erektionsstörungen. Sie tragen somit zur
            Wiederherstellung oder Verbesserung der sexuellen Leistung bei,
            jedoch unwesentlich zur Grösse.
          </p>

          <Quote side='right'>
            <div className='ui small header turquoise'>
              «Ein Patient hatte seinen Penis in eine Cola-Flasche gesteckt»
            </div>
          </Quote>

          <p className='question'>
            Als Urologe ist man sicher auch mit anderen kuriosen Anliegen oder
            Problemen konfrontiert. Was ist Ihnen da schon vorgekommen?
          </p>
          <p>
            Nun, ein Patient hatte seinen Penis in eine Cola-Flasche gesteckt
            und bekam diese nicht mehr runter. Das ist tragischerweise so weit
            gegangen, dass er einen Teil seines besten Stücks verloren hat.
          </p>

          <p className='question'>Auch ein Tabuthema: unfruchtbare Männer.</p>
          <p>
            Statistisch liegt Unfruchtbarkeit bei Paaren in einem Drittel nur
            bei der Frau, in einem Drittel nur beim Mann. In einem weiteren
            Drittel liegt es an beiden. Wenn ein Mann wegen Unfruchtbarkeit bei
            mir landet, kommt die Frau interessanterweise meistens mit. Bei den
            Gynäkologen sieht man die Partner in solchen Situationen weniger.
          </p>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  // eslint-disable-next-line
                  event_action: 'vertical-scroll',
                  // eslint-disable-next-line
                  event_label: '50ContentRead'
                })
              }
            }}
          />

          <p className='question'>
            Frauen gehen schon als Mädchen zum Frauenarzt. Ab wann sollten
            Männer dies tun?{' '}
          </p>
          <p>
            Männer sollten ab dem 40. Lebensjahr regelmässig zum Urologen. Ich
            plädiere dafür schon viel früher, zwischen 20 und 30 mit einem
            ersten harmlosen Check zu starten. Dabei ist keine
            Fingeruntersuchung notwendig, man schaut, ob Risikofaktoren
            vorhanden sind, und bespricht Themen wie Fruchtbarkeit, Sexualität
            und Geschlechtskrankheiten. Es geht vor allem ums Umdenken: Dass
            Männergesundheit den gleichen Stellenwert hat wie Frauengesundheit.
            Dass Männer schon früher lernen, über ihre Probleme zu sprechen –
            dann ist ein Erektionsverlust oder Ejakulationsproblem später auch
            keine Katastrophe mehr. Dasselbe gilt für den Prostatakrebs, der im
            Unterschied zum Mammakarzinom immer noch ein Tabuthema ist – in das
            interessanterweise auch weniger Forschungsgeld investiert wird.
            <Quote side='left'>
              <div className='ui small header turquoise'>
                «Viele Männer kennen den Begriff Andropause gar nicht»
              </div>
            </Quote>
          </p>

          <p className='question'>
            Für Frauen ist die Menopause ein grosses Thema. Wie blicken die
            Männer auf die Andropause?
          </p>
          <p>
            Viele Männer kennen den Begriff gar nicht. Sie spüren den langsamen
            Abfall des Testosteronspiegels, der in der Regel zwischen 45 und 65
            eintritt, oft nur schleichend und viel später. Die Menopause
            hingegen tritt schneller ein, wenn die Eizellen verbraucht sind, was
            zu den typischen Menopausen-Beschwerden führt. Einen
            Testosteronmangel fürchten die Männer aber ebenso. In Zeiten, in
            denen alles optimiert werden kann, ist der Wunsch nach mehr
            Testosteron weit verbreitet. Es gibt tatsächlich viele Männer, die
            zu wenig Testosteron haben. Aber auch solche, die genug haben, aber
            noch mehr zu sich nehmen. Beides ist nicht gut.
          </p>

          <p className='question'>
            Stimmt es, dass der Testosteronspiegel der Männer über die letzten
            Jahrzehnte abgenommen hat?
          </p>
          <p>
            Ja, das konnten Studien belegen. Gerade Faktoren wie Stress oder zu
            wenig Bewegung scheinen auf die Abnahme des Testosteronspiegels
            einen grossen Einfluss zu haben.
          </p>

          <p className='question'>
            Wie merkt man, dass ein Testosteronmangel vorliegt?
          </p>
          <p>
            Sexuelle Lustlosigkeit, Abnahme der Muskelmasse, Schlafbeschwerden
            und Hitzewallungen sind typische Symptome, die auf einen
            Testosteronmangel hinweisen können – aber natürlich auch andere,
            psychische oder physische Ursachen haben können. Auch
            Antriebslosigkeit, die zu einer depressiven Verstimmung führen kann,
            ist ein weiteres Symptom. Es gibt nicht nur ein psychisches
            Burn-out, sondern auch ein hormonelles.{' '}
          </p>

          <p className='question'>Was tun bei Testosteronmangel?</p>
          <p>
            Weniger Bauchfett und mehr Sport können Wunder bewirken. Wobei zu
            viel Ausdauersport den Testosteronspiegel eher senkt und Kraftaufbau
            ihn erhöht. Auch bei den Hormonen ist eine gesunde Lebensführung die
            beste Medizin. Testosteron-Gels oder -Injektionen sollte man nur vom
            Arzt verschrieben anwenden, denn die Nebenwirkungen können erheblich
            sein. Die Fruchtbarkeit zum Beispiel wird hochgradig negativ
            beeinflusst. Übrigens haben laut einer Studie verheiratete Männer
            einen tieferen Testosteronspiegel... aber lassen Sie sich deshalb
            bitte nicht scheiden.
          </p>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  // eslint-disable-next-line
                  event_action: 'vertical-scroll',
                  // eslint-disable-next-line
                  event_label: '75ContentRead'
                })
              }
            }}
          />
        </div>
      </div>
      <div className='ui vertical fitted segment' id='testosteroncheck'>
        <div className='ui text container'>
          <h4 className='testTitle'>
            Test: The Aging Males' Symptoms (AMS) Scale
          </h4>
          <p className='testIntro'>
            Da die Produktion der männlichen Hormone ab einem Alter von 40
            Jahren – manchmal auch früher – langsam absinkt, nehmen Männer im
            Allgemeinen die Symptome erst spät wahr und bringen sie eventuell
            nicht mit der tatsächlichen Ursache in Verbindung. Der so genannte
            AMS-Fragebogen dient in der Urologie der Erfassung altersbedingter
            Beschwerden, die neben anderen Ursachen auch durch erniedrigte
            Testosteron-Serumspiegel bedingt sein können. Die Fragen wurden auf
            der Basis eines internationalen Standards erstellt. Der
            AMS-Fragebogen kann zur Vorbereitung auf ein ärztliches Gespräch
            genutzt werden, ersetzt dieses aber auf keinen Fall.
          </p>
          <Questionnaire />
        </div>
      </div>

      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        credits={[
          ['Interview', 'Philippe Zweifel'],
          [
            'Digitale Umsetzung und Programmierung',
            'Kaspar Manz und Patrick Vögeli'
          ]
        ]}
        hidePortfolioTeaser
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie nützlich war der Testosteroncheck (AMS)?'
        ]}
      />
    </div>
  )
}
